import { createTheme } from '@material-ui/core/styles';
import { TOKENS } from '../styles/tokens';

/**
 * cpgThemeV4 — MUI v4 companion to cpgTheme.
 *
 * A few shared `@monorepo/common` components (notably `Loader`) still style
 * themselves with v4 `makeStyles` JSS that resolves `theme.palette.*` against the
 * MUI v4 theme — not the v5 `cpgTheme`. With no v4 provider those spots fall back
 * to the default v4 palette (indigo/purple), most visibly the page loader and the
 * Copy modal spinner. This theme carries the brand blue onto v4 so they match the
 * v5 UI. Values come from src/styles/tokens.ts (keep in sync with cpgTheme.ts).
 */
export const cpgThemeV4 = createTheme({
  palette: {
    primary: {
      main: TOKENS.accent,
      dark: TOKENS.accentDeep,
      contrastText: '#fff',
    },
  },
});

export default cpgThemeV4;
